import { render, staticRenderFns } from "./StockCompareMetricsTable.vue?vue&type=template&id=27af9142&scoped=true&"
import script from "./StockCompareMetricsTable.vue?vue&type=script&lang=js&"
export * from "./StockCompareMetricsTable.vue?vue&type=script&lang=js&"
import style0 from "./StockCompareMetricsTable.vue?vue&type=style&index=0&id=27af9142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27af9142",
  null
  
)

export default component.exports